<p-dialog header="Configure Report" [(visible)]="visible" [modal]="true">
  <div class="configure-report-modal-wrapper">
    <div class="modal-header">
      <span class="modal-subtitle"
        >Select the fields to include for further filtering and
        customization.</span
      >
    </div>
    <div class="modal-content">
      <div class="all-section modal-section">
        <div class="section-header">
          <span class="section-title">All</span>
          <span class="total-items"
            >{{filteredUnselectedFields.length}} items</span
          >
        </div>
        <div class="section-content">
          <div class="section-search">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              class="search-icon"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.58268 3.33329C6.1309 3.33329 3.33268 6.13151 3.33268 9.58329C3.33268 13.0351 6.1309 15.8333 9.58268 15.8333C11.2603 15.8333 12.7835 15.1723 13.9061 14.0967C13.932 14.0607 13.9612 14.0264 13.9935 13.994C14.0259 13.9617 14.0602 13.9326 14.0961 13.9067C15.1718 12.784 15.8327 11.2608 15.8327 9.58329C15.8327 6.13151 13.0345 3.33329 9.58268 3.33329ZM15.739 14.561C16.8399 13.2011 17.4993 11.4692 17.4993 9.58329C17.4993 5.21104 13.9549 1.66663 9.58268 1.66663C5.21043 1.66663 1.66602 5.21104 1.66602 9.58329C1.66602 13.9555 5.21043 17.5 9.58268 17.5C11.4687 17.5 13.2006 16.8405 14.5605 15.7395L16.9101 18.0892C17.2355 18.4146 17.7632 18.4147 18.0886 18.0892C18.414 17.7638 18.414 17.2362 18.0886 16.9107L15.739 14.561Z"
                fill="#5D6983"
              />
            </svg>
            <input
              id="inputRangePicker"
              [(ngModel)]="searchQuery"
              placeholder="Search"
              class="form-control-field search-field"
              pInputText
            />
            @if(searchQuery) {
            <svg
              (click)="searchQuery = ''"
              class="clear-icon"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z"
                fill="#5D6983"
              ></path>
            </svg>
            }
          </div>
          <div class="section-list">
            <ul class="list-items">
              @if(filteredUnselectedFields && filteredUnselectedFields.length) {
              <li class="select-all-item list-item">
                <p-checkbox
                  [binary]="true"
                  inputId="selectAllList"
                  [ngModel]="isAllVisibleSelected"
                  (onChange)="selectVisibleFields($event.checked)"
                />
                <label for="selectAllList">Select All</label>
              </li>
              } @for (item of filteredUnselectedFields; track item.field_id) {
              <li
                class="list-item"
                [ngStyle]="{cursor: item.required && 'auto'}"
              >
                <div class="checkbox-wrapper">
                  <p-checkbox
                    (onChange)="onItemChange(item)"
                    [disabled]="!!item.required"
                    [binary]="true"
                    [inputId]="'checkbox-' + item.field_id"
                    [(ngModel)]="item.selected"
                  >
                  </p-checkbox>
                  <label
                    [for]="'checkbox-' + item.field_id"
                    [ngStyle]="{color: item.required ? '#dee1e7' : '#252A34', cursor: item.required && 'auto'}"
                    >{{ item.field_name }}</label
                  >
                </div>
              </li>
              }
            </ul>
          </div>
        </div>
      </div>
      <div class="selected-section modal-section">
        <div class="section-header">
          <span class="section-title">Selected</span>
          <span class="total-items">{{selectedList.length}} items</span>
          <span class="section-header-action" (click)="resetToDefault()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.666016 8.00004C0.666016 4.31814 3.65078 1.33337 7.33268 1.33337C9.17428 1.33337 10.8425 2.08097 12.0484 3.28763C12.4748 3.71435 12.9314 4.24169 13.3327 4.72967V2.66671C13.3327 2.29852 13.6312 2.00004 13.9993 2.00004C14.3675 2.00004 14.666 2.29852 14.666 2.66671V6.66671C14.666 7.0349 14.3675 7.33337 13.9993 7.33337H9.99935C9.63116 7.33337 9.33268 7.0349 9.33268 6.66671C9.33268 6.29852 9.63116 6.00004 9.99935 6.00004H12.6455C12.184 5.42089 11.6104 4.73561 11.1052 4.23011C10.1392 3.26347 8.80629 2.66671 7.33268 2.66671C4.38716 2.66671 1.99935 5.05452 1.99935 8.00004C1.99935 10.9456 4.38716 13.3334 7.33268 13.3334C9.76317 13.3334 11.8155 11.707 12.4576 9.48187C12.5597 9.12812 12.9292 8.92409 13.283 9.02618C13.6368 9.12826 13.8408 9.49779 13.7387 9.85154C12.9363 12.6321 10.373 14.6667 7.33268 14.6667C3.65078 14.6667 0.666016 11.6819 0.666016 8.00004Z"
                fill="#0076DD"
              />
            </svg>
            Reset to Default</span
          >
        </div>
        <div class="section-list">
          <ul class="list-items">
            @for (item of selectedList; track item.field_id; let i = $index) {
            <li
              class="list-item selected-list-item"
              pDraggable
              pDroppable
              dragEffect="move"
              (onDragStart)="onDragStart($event, item, i)"
              (onDragEnd)="onDragEnd()"
              (onDragEnter)="onDragEnter(i)"
            >
              <span class="list-item-drag-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M13.3333 5.00004C13.7936 5.00004 14.1667 4.62694 14.1667 4.16671C14.1667 3.70647 13.7936 3.33337 13.3333 3.33337C12.8731 3.33337 12.5 3.70647 12.5 4.16671C12.5 4.62694 12.8731 5.00004 13.3333 5.00004Z"
                    stroke="#7985A0"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.3333 10.8333C13.7936 10.8333 14.1667 10.4602 14.1667 9.99996C14.1667 9.53971 13.7936 9.16663 13.3333 9.16663C12.8731 9.16663 12.5 9.53971 12.5 9.99996C12.5 10.4602 12.8731 10.8333 13.3333 10.8333Z"
                    stroke="#7985A0"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.3333 16.6667C13.7936 16.6667 14.1667 16.2936 14.1667 15.8333C14.1667 15.3731 13.7936 15 13.3333 15C12.8731 15 12.5 15.3731 12.5 15.8333C12.5 16.2936 12.8731 16.6667 13.3333 16.6667Z"
                    stroke="#7985A0"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.49935 5.00004C7.95958 5.00004 8.33268 4.62694 8.33268 4.16671C8.33268 3.70647 7.95958 3.33337 7.49935 3.33337C7.03912 3.33337 6.66602 3.70647 6.66602 4.16671C6.66602 4.62694 7.03912 5.00004 7.49935 5.00004Z"
                    stroke="#7985A0"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.49935 10.8333C7.95958 10.8333 8.33268 10.4602 8.33268 9.99996C8.33268 9.53971 7.95958 9.16663 7.49935 9.16663C7.03912 9.16663 6.66602 9.53971 6.66602 9.99996C6.66602 10.4602 7.03912 10.8333 7.49935 10.8333Z"
                    stroke="#7985A0"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.49935 16.6667C7.95958 16.6667 8.33268 16.2936 8.33268 15.8333C8.33268 15.3731 7.95958 15 7.49935 15C7.03912 15 6.66602 15.3731 6.66602 15.8333C6.66602 16.2936 7.03912 16.6667 7.49935 16.6667Z"
                    stroke="#7985A0"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="list-item-text">{{ item.field_name }}</span>
              @if(!item.required) {
              <span
                class="list-item-remove-icon"
                (click)="removeListItem(item)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.64645 2.64645C2.84171 2.45118 3.15829 2.45118 3.35355 2.64645L6 5.29289L8.64645 2.64645C8.84171 2.45118 9.15829 2.45118 9.35355 2.64645C9.54882 2.84171 9.54882 3.15829 9.35355 3.35355L6.70711 6L9.35355 8.64645C9.54882 8.84171 9.54882 9.15829 9.35355 9.35355C9.15829 9.54882 8.84171 9.54882 8.64645 9.35355L6 6.70711L3.35355 9.35355C3.15829 9.54882 2.84171 9.54882 2.64645 9.35355C2.45118 9.15829 2.45118 8.84171 2.64645 8.64645L5.29289 6L2.64645 3.35355C2.45118 3.15829 2.45118 2.84171 2.64645 2.64645Z"
                    fill="#5D6983"
                  />
                </svg>
              </span>
              }
            </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div
      style="
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      "
    >
      <lib-dm-button-lib
        text="Cancel"
        size="medium"
        variant="secondary-outlined"
        (outsideClickEmitter)="visible.set(false)"
      />
      <lib-dm-button-lib
        text="Apply"
        size="medium"
        variant="primary-filled"
        (outsideClickEmitter)="apply()"
      />
    </div>
  </ng-template>
</p-dialog>
